export const PERSONAL_NOTES_REQUEST = 'PERSONAL_NOTES_REQUEST';
export const PERSONAL_NOTES_REQUEST_SUCCESS = 'PERSONAL_NOTES_REQUEST_SUCCESS';
export const PERSONAL_NOTES_REQUEST_FAILURE = 'PERSONAL_NOTES_REQUEST_FAILURE';
export const PERSONAL_NOTES_STORE_PUT = 'PERSONAL_NOTES_STORE_PUT';
export const PERSONAL_NOTES_STORE_PUT_SUCCESS = 'PERSONAL_NOTES_STORE_PUT_SUCCESS';
export const PERSONAL_NOTES_STORE_PUT_FAILURE = 'PERSONAL_NOTES_STORE_PUT_FAILURE';
export const PERSONAL_NOTES_STORE_POST = 'PERSONAL_NOTES_STORE_POST';
export const PERSONAL_NOTES_STORE_POST_SUCCESS = 'PERSONAL_NOTES_STORE_POST_SUCCESS';
export const PERSONAL_NOTES_STORE_POST_FAILURE = 'PERSONAL_NOTES_STORE_POST_FAILURE';
export const FILING_NOTES_REQUEST = 'FILING_NOTES_REQUEST';
export const FILING_NOTES_REQUEST_SUCCESS = 'FILING_NOTES_REQUEST_SUCCESS';
export const FILING_NOTES_REQUEST_FAILURE = 'FILING_NOTES_REQUEST_FAILURE';
export const FILING_NOTES_STORE_POST = 'FILING_NOTES_STORE_POST';
export const FILING_NOTES_STORE_POST_SUCCESS = 'FILING_NOTES_STORE_POST_SUCCESS';
export const FILING_NOTES_STORE_POST_FAILURE = 'FILING_NOTES_STORE_POST_FAILURE';
export const FILING_NOTES_STORE_PUT = 'FILING_NOTES_STORE_PUT';
export const FILING_NOTES_STORE_PUT_SUCCESS = 'FILING_NOTES_STORE_PUT_SUCCESS';
export const FILING_NOTES_STORE_PUT_FAILURE = 'FILING_NOTES_STORE_PUT_FAILURE';
